import LocalizationProvider from "./localization-provider.jsx";

export default LocalizationProvider;